import { history, useLocation, useIntl } from 'umi';
import React, { useState } from 'react';
import { useDispatch } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import { Button, Box, useTheme, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { optionToKey, fmtThousand } from '@/utils/comUtil.js';
import { sexMap, channelMap } from '@/constants.js';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import TablePageStyled from './TablePageStyled.jsx';
import { createOid } from '@/utils/eventtracing';
import request from '@/utils/request';
import webStorage from '@/utils/storageManager';

const TablePage = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { pathname, query } = location;
  const theme = useTheme();
  const dispatch = useDispatch();
  //关于退会弹窗
  const { IDENTITY_TYPE_SYNC_PLATFORM } = webStorage.get('DICTOBJ');
  const [openDialog, setOPenDialog] = useState(false);
  const [openIdentityDialog, setOPenIdentityDialog] = useState(false);
  const [identityData, setIdentityData] = useState([]);
  const [isExit, setIsExit] = useState(false);
  const handleCloseDialog = () => {
    setOPenDialog(false);
  };

  const judgeIdentity = async (data) => {
    const res = await request('/member/queryMemberInfo', {
      method: 'POST',
      data: {
        id: data.id,
      },
    });

    const identityList = res?.data?.identityList || [];
    const hasIdentity =
      identityList.filter(
        (item) =>
          IDENTITY_TYPE_SYNC_PLATFORM.findIndex(
            (i) => i.dictCode === item.type,
          ) > -1,
      ) || [];
    const onlyIdentity = [];
    hasIdentity.forEach((item) => {
      if (
        onlyIdentity.findIndex((i) => i.storeName === item.storeName) === -1
      ) {
        onlyIdentity.push(item);
      }
    });
    if (onlyIdentity.length > 0) {
      setIdentityData(onlyIdentity);
      setOPenIdentityDialog(true);
    } else {
      setOPenDialog(true);
    }
  };
  //每一行会员数据
  const [rowData, setRowData] = useState();
  const handleExit = () => {
    if (isExit) {
      return false;
    }
    setIsExit(true);
    dispatch({
      type: 'adjustDetail/memberManualOperation',
      payload: {
        values: {
          type: 'EXIT',
          memberId: rowData.id,
          mobile: rowData.mobile,
          value: rowData.memberCode,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setOPenDialog(false);
          const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
          history.replace(
            `${pathname}?${qs.stringify({
              ...query,
              refreshTime: time,
            })}`,
          );
          window.message.toast({
            type: 'success',
            message: '退会成功',
            title: '成功',
          });
        }
        setIsExit(false);
      },
    });
  };

  const {
    pagination,
    total,
    allTotal,
    loading,
    setColumn,
    setSort,
    hasNext,
    tableData,
    setPageData,
  } = props || {};
  const handleMemberDetail = (record, status) => {
    const { name, gender, level, mobile, memberCode } = record;
    history.push({
      pathname:
        status === 'coupon'
          ? '/adjust/adjust_list/patch_coupon'
          : `/adjust/adjust_list/${status}`,
      query: {
        id: String(record.id),
        status: status,
        tab: 1,
        name,
        gender,
        level,
        mobile,
        memberCode,
      },
    });
  };

  const columns = [
    {
      align: 'center',
      title: formatMessage({ id: 'adjustment.members.c01.lbl01' }),
      id: 'memberCode',
      width: 180,
      render: ({ memberCode }) => {
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        return <div>{memberCode}</div>;
      },
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl02' }),
      align: 'center',
      id: 'name',
      key: 'name',
      width: 120,
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl03' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 180,
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl04' }),
      id: 'gender',
      key: 'gender',
      width: 100,
      align: 'center',
      render: (text) => {
        let sex = '';
        sex = optionToKey(sexMap, text.gender);
        return sex;
      },
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl05' }),
      id: 'level',
      key: 'level',
      align: 'center',
      width: 120,
    },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl06' }),
      id: 'availablePoint',
      key: 'availablePoint',
      width: 140,
      align: 'right',
      sortDirections: ['ascend', 'descend', 'default'],
      render: (item) => {
        return (
          <span textAlign="center">
            {item.availablePoint !== null
              ? fmtThousand(item.availablePoint, 0)
              : ''}
          </span>
        );
      },
    },
    // {
    //   title: formatMessage({ id: 'adjustment.members.c01.lbl07' }),
    //   id: 'channel',
    //   key: 'channel',
    //   width: 150,
    //   align: 'center',
    //   render: ({ channel: text }) => {
    //     let grade = '';
    //     grade = optionToKey(channelMap, text);
    //     return grade;
    //   },
    // },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl08' }),
      id: 'signUpDate',
      key: 'signUpDate',
      width: 140,
      align: 'center',
      sortDirections: ['ascend', 'descend', 'default'],
      sorter: (a, b, c) => {
        setColumn('SIGN_UP_DATE');
        setSort(c);
        return false;
      },

      render: ({ signUpDate: text }) => (
        <div>{dayjs(text).format('YYYY-MM-DD')}</div>
      ),
    },
    // {
    //   title: formatMessage({ id: 'adjustment.members.c01.lbl09' }),
    //   id: 'subCompanyName',
    //   key: 'subCompanyName',
    //   width: 150,
    //   align: 'center',
    // },
    // {
    //   title: formatMessage({ id: 'adjustment.members.c01.lbl10' }),
    //   id: 'registerStoreName',
    //   key: 'registerStoreName',
    //   width: 150,
    //   align: 'center',
    // },
    // {
    //   title: formatMessage({ id: 'adjustment.members.c01.lbl11' }),
    //   id: 'mangeStoreName',
    //   key: 'mangeStoreName',
    //   width: 150,
    //   align: 'center',
    // },
    {
      title: formatMessage({ id: 'adjustment.members.c01.lbl12' }),
      width: 300,
      align: 'center',
      render: (recor) => {
        return (
          <div align="center" className={'handle_btn'}>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: createOid('ec'),
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => handleMemberDetail(recor, 'edit')}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="优惠券">
              <IconButton
                data-log={JSON.stringify({
                  oid: createOid('ec'),
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => handleMemberDetail(recor, 'coupon')}
              >
                <SvgIconML
                  name="couponListIcon"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip
              title={formatMessage({ id: 'adjustment.members.c01.lbl20' })}
            >
              <IconButton
                data-log={JSON.stringify({
                  oid: 'page_manual_adjustment_member_adjust_points',
                  events: ['_pv', '_pc'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => handleMemberDetail(recor, 'changeIntegral')}
              >
                <SvgIconML
                  name="changeIntegral"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip
              title={formatMessage({ id: 'adjustment.members.c01.lbl19' })}
            >
              <IconButton
                data-log={JSON.stringify({
                  oid: 'page_manual_adjustment_member_adjust_level',
                  events: ['_pv', '_pc'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => handleMemberDetail(recor, 'changeLevel')}
              >
                <SvgIconML
                  name="changeLevel"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip
              title={formatMessage({ id: 'adjustment.members.c01.lbl22' })}
            >
              <IconButton
                data-log={JSON.stringify({
                  oid: createOid('ec'),
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  setRowData(recor);
                  // setOPenDialog(true);
                  judgeIdentity(recor);
                }}
              >
                <SvgIconML
                  name="exitMeeting"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="解绑">
              <IconButton
                onClick={() => {
                  handleClickRemoveBind(recor);
                }}
              >
                <SvgIconML
                  name="unbind-icon"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  //解绑
  const handleClickRemoveBind = (data) => {
    history.push({
      pathname: '/adjust/adjust_list/unbind_member',
      query: {
        id: data.id,
      },
    });
  };

  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'coupon.data.n02.lbl02' })}{' '}
        </span>
        <span> {fmtThousand(allTotal, 0)}</span>
      </div>
    </div>
  );

  //新建二维码分组自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
          marginTop: '-8px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseIdentityDialog}
          color="secondary"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
        >
          关闭
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };
  const onCloseIdentityDialog = () => {
    setOPenIdentityDialog(false);
  };
  const identityContent = () => {
    return (
      <div>
        <div
          style={{
            marginBottom: '24px',
            background: 'oldlace',
            padding: '6px 12px',
          }}
        >
          会员仍存在未解绑的店铺，请先完成解绑后再操作退会处理。
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            marginBottom: '10px',
            borderBottom: '1px solid rgb(239, 239, 239, 1)',
          }}
        >
          <div style={{ width: '100px' }}>渠道</div>
          <div style={{ width: '320px' }}>店铺名称</div>
          <div style={{ width: '100px' }}>绑定状态</div>
        </div>
        {identityData?.map((item) => (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              lineHeight: '48px',
              borderBottom: '1px solid rgb(239, 239, 239, 1)',
            }}
          >
            <div style={{ width: '100px' }}>
              {optionToKey(channelMap, item.channel)}
            </div>
            <div style={{ width: '320px' }}>{item.storeName}</div>
            <div style={{ width: '100px' }}>绑定中</div>
          </div>
        ))}
      </div>
    );
  };
  return (
    <TablePageStyled>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        headerTip={headerTip}
        hasNext={hasNext}
        initP={true}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={tableData}
        columnKey="id"
      ></DataTableNativeML>
      <DialogDataML
        open={openDialog}
        title={formatMessage({ id: 'adjustment.members.d01.lbl01' })}
        content={
          <>
            {formatMessage({ id: 'adjustment.members.d01.txt02' })}
            <span className="warning">
              {formatMessage({ id: 'adjustment.members.d01.txt03' })}
            </span>
            ，{formatMessage({ id: 'adjustment.members.d01.txt04' })}
          </>
        }
        handleClose={handleCloseDialog}
        handleConfirm={handleExit}
      ></DialogDataML>
      <DialogDataML
        open={openIdentityDialog}
        title={
          <div
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              退会提醒
            </span>
          </div>
        }
        content={identityContent()}
        handleClose={onCloseIdentityDialog}
        button={initButton()}
      />
    </TablePageStyled>
  );
};
export default TablePage;
